import { Controller, useForm } from 'react-hook-form';
import { Button, Col, Form, Row } from 'react-bootstrap';
import { Input, Select } from 'antd';
import { t } from 'i18next';
import { useAppDispatch, useAppSelector } from 'core/store/hooks';
import { StatusBadgeData } from 'enums/status';
import LinksButton from 'shared/design-system/components/links-button';
import { filtersDashboardProjectSelector, filtersDashboardProjectUsedSelector } from '../_redux/selectors';
import { saveDashboardProjectFilters } from '../_redux/actions';
import { filterOption } from 'shared/utils/common.utils';
import TagMultipleSelect from 'shared/design-system/components/app-tag-multiple-select';
import useGetAllActiveUsers from 'shared/_hooks/useGetAllActiveUsers';
import { FilterPeriodEnum, FilterPeriodLabelsEnum } from 'enums/dashboard.enum';

export const filtersDashboardProjectsData: any = {
  id: '',
  nome: '',
  projectStatus: [],
  revenueType: [],
  businessUnit: null,
  idCliente: null,
  plUserId: null,
  plUserLv2Id: null,
  delegateUserId: null,
  filtroAnnualita: null,
};

interface Props {
  onSubmit: any;
  handleReset: () => void;
}
const FiltersDashboardProjects = ({ onSubmit, handleReset }: Props) => {
  const filterUsed = useAppSelector(filtersDashboardProjectUsedSelector);
  const dispatch = useAppDispatch();
  const allUsers = useGetAllActiveUsers();
  const { control, register, handleSubmit, reset } = useForm({
    defaultValues: filtersDashboardProjectsData,
    values: filterUsed,
  });
  const filtri = useAppSelector(filtersDashboardProjectSelector);

  const Reset = () => {
    reset();
    handleReset();
  };

  const handleFormSubmit = async (formData: any) => {
    dispatch(saveDashboardProjectFilters(formData));
    try {
      await onSubmit(formData);
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  return (
    <Form className="grid" onSubmit={handleSubmit(handleFormSubmit)}>
      <Row>
        <Col sm="3">
          <Form.Label>{t('dashboard.projects.filters.id-project')}</Form.Label>
          <Controller
            name="id"
            control={control}
            render={({ field }) => (
              <Input
                type="number"
                placeholder={t('project-list.id-project-placeholder')}
                size="large"
                allowClear
                style={{ width: '100%' }}
                value={field.value}
                onChange={(value) => field.onChange(value)}
              />
            )}
          />
        </Col>
        <Col sm="3">
          <Form.Label>{t('dashboard.projects.filters.project-name')}</Form.Label>
          <Controller
            name="nome"
            control={control}
            render={({ field }) => (
              <Input
                type="text"
                placeholder={t('project-list.search-name-project')}
                size="large"
                allowClear
                style={{ width: '100%' }}
                value={field.value}
                onChange={(value) => field.onChange(value)}
              />
            )}
          />
        </Col>
        <Col sm="3">
          {' '}
          <Form.Label>{t('dashboard.projects.filters.states')}</Form.Label>
          <Controller
            name="projectStatus"
            control={control}
            render={({ field }) => (
              <Select
                placeholder={t('project-list.select-status-placeholder')}
                mode="multiple"
                size="large"
                allowClear
                tagRender={TagMultipleSelect}
                defaultValue={[]}
                style={{ width: '100%' }}
                options={filtri?.statoEnum?.map((el: any, index: any) => ({
                  value: el,
                  label: StatusBadgeData?.find((state) => state.name === el)?.filterLabel,
                }))}
                {...field}
              />
            )}
          />
        </Col>
        <Col sm="3">
          <Form.Label>{t('dashboard.projects.filters.business-unit')}</Form.Label>
          <Controller
            name="businessUnit"
            control={control}
            render={({ field }) => (
              <Select
                showSearch
                size="large"
                className="w-100"
                allowClear
                value={field.value}
                onChange={(value) => field.onChange(value)}
                onBlur={field.onBlur}
                placeholder={t('cdg.business-unit-placeholder')}
              >
                {filtri?.businessUnit?.map((el, index) => (
                  <Select.Option key={index} value={el.name}>
                    {el.name}
                  </Select.Option>
                ))}
              </Select>
            )}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm="3">
          <Form.Label>{t('dashboard.projects.filters.account')}</Form.Label>
          <Controller
            name="idCliente"
            control={control}
            render={({ field }) => (
              <Select
                showSearch
                size="large"
                className="w-100"
                allowClear
                optionFilterProp="children"
                filterOption={filterOption}
                value={field.value}
                onChange={(value) => field.onChange(value)}
                onBlur={field.onBlur}
                placeholder={t('dashboard.projects.filters.search-account-placeholder')}
              >
                {filtri?.clientIds?.map((el, index) => (
                  <Select.Option key={index} value={el.id}>
                    {el.denominazione}
                  </Select.Option>
                ))}
              </Select>
            )}
          />
        </Col>
        <Col sm="3">
          <Form.Label>{t('dashboard.projects.filters.project-lead')}</Form.Label>
          <Controller
            name="plUserId"
            control={control}
            render={({ field }) => (
              <Select
                showSearch
                size="large"
                className="w-100"
                allowClear
                optionFilterProp="children"
                filterOption={filterOption}
                value={field.value}
                onChange={(value) => field.onChange(value)}
                onBlur={field.onBlur}
                placeholder={t('dashboard.projects.filters.search-pl-placeholder')}
              >
                {filtri?.projectLeads?.map((el, index) => (
                  <Select.Option key={index} value={el.id}>
                    {el.nominativo}
                  </Select.Option>
                ))}
              </Select>
            )}
          />
        </Col>
        <Col sm="3">
          <Form.Label>{t('dashboard.projects.filters.project-lead-lv-2')}</Form.Label>
          <Controller
            name="plUserLv2Id"
            control={control}
            render={({ field }) => (
              <Select
                showSearch
                size="large"
                className="w-100"
                allowClear
                optionFilterProp="children"
                filterOption={filterOption}
                value={field.value}
                onChange={(value) => field.onChange(value)}
                onBlur={field.onBlur}
                placeholder={t('dashboard.projects.filters.search-pl-lv-2-placeholder')}
              >
                {filtri?.projectLeads?.map((el, index) => (
                  <Select.Option key={index} value={el.id}>
                    {el.nominativo}
                  </Select.Option>
                ))}
              </Select>
            )}
          />
        </Col>
        <Col sm="3">
          <Form.Label>{t('dashboard.projects.filters.delegate')}</Form.Label>
          <Controller
            name="delegateUserId"
            control={control}
            render={({ field }) => (
              <Select
                showSearch
                size="large"
                className="w-100"
                allowClear
                optionFilterProp="children"
                filterOption={filterOption}
                value={field.value}
                onChange={(value) => field.onChange(value)}
                onBlur={field.onBlur}
                placeholder={t('dashboard.projects.filters.search-delegate-placeholder')}
              >
                {allUsers?.map((el, index) => (
                  <Select.Option key={index} value={el.id}>
                    {el.nominativo}
                  </Select.Option>
                ))}
              </Select>
            )}
          />
        </Col>
      </Row>
      <Row className="mt-3">
        <Col sm="3">
          <Form.Label>{t('Revenue type')}</Form.Label>
          <Controller
            name="revenueType"
            control={control}
            render={({ field }) => (
              <Select
                mode="multiple"
                size="large"
                className="w-100"
                allowClear
                tagRender={TagMultipleSelect}
                placeholder={t('Seleziona tipologia')}
                options={(filtri?.revenueType ?? []).map((el: any) => ({ value: el, label: el }))}
                {...field}
              />
            )}
          />
        </Col>
        <Col sm="3">
          <Form.Label>{t('dashboard.projects.filters.period')}</Form.Label>
          <Controller
            name="filtroAnnualita"
            control={control}
            render={({ field }) => (
              <Select
                showSearch
                size="large"
                className="w-100"
                allowClear
                optionFilterProp="children"
                filterOption={filterOption}
                value={field.value}
                onChange={(value) => field.onChange(value)}
                onBlur={field.onBlur}
                placeholder={t('dashboard.projects.filters.search-period-placeholder')}
              >
                <Select.Option value={FilterPeriodEnum.TOTAL}>{FilterPeriodLabelsEnum.TOTAL}</Select.Option>
                <Select.Option value={FilterPeriodEnum.PREC_YEAR}>{FilterPeriodLabelsEnum.PREC_YEAR}</Select.Option>
                <Select.Option value={FilterPeriodEnum.CURRENT_YEAR}>
                  {FilterPeriodLabelsEnum.CURRENT_YEAR}
                </Select.Option>
              </Select>
            )}
          />
        </Col>
      </Row>

      <div className="d-flex mt-3">
        <div className="d-flex ms-auto">
          <Button className="btn text-danger trash-btn" type="button" variant="icon" onClick={Reset}>
            <i className="fa-regular fa-trash-can me-2" />
            {t('project-list.delete-filters')}
          </Button>
          <LinksButton type="submit" className="btn-sm btn-primary btn-links px-4">
            <i className="fa-solid fa-magnifying-glass me-2" />
            {t('project-list.search')}
          </LinksButton>
        </div>
      </div>
    </Form>
  );
};
export default FiltersDashboardProjects;
